export const updateLocation = () => {
  window.Beacon?.('event', {
    type: 'page-viewed',
    url: document.location.href,
    title: document.title,
  });
  window.Beacon?.('suggest');
};
